var React = require('react');
var ReactDOM = require('react-dom');
var ReactRouter = require('react-router');
var Link = ReactRouter.Link;
var Shopify = require('./shopify');
var Utils = require('./utils');
var HeaderPage = require('./header-page');
var ScrollToTop = require('./scroll-to-top');

var Store = React.createClass({

  mounted: false,
  borderHei: 0,

  componentDidMount: function() {

    document.title = "Our Stores - Ingledew's Shoes";

    this.mounted = true;
    if (this.borderHei) {
      var dfb = ReactDOM.findDOMNode(this.refs.divForBoder);
      jQuery(dfb).height(hei);
    }
    
    setTimeout(function() { jQuery(window).scroll(); }, 300);
  },

  requestFitting: function() {
    this.props.showFittingReqForm(this.props.store.title);
  },

  setBorderDivHei: function(hei) {
    jQuery('.store .for-border').height(hei);
  },

  imageLoaded: function() {
    this.props.imageLoaded(jQuery(ReactDOM.findDOMNode(this.refs.divForBoder)).height());
  },

  render: function() {
    var store = this.props.store;
    var hour4 = store.hours4 ? <li>{store.hours4}</li> : [];
    var ecco = null;

    if (store.subtitle) {
      var breakPoint = store.subtitle.indexOf("Ecco");
      var before = store.subtitle.substring(0, breakPoint);
      var after = store.subtitle.substring(breakPoint + 5);

      ecco = <p className="sub-title">{before}<img src={CMS.stores.eccoLogo} />{after}</p>
    }
    var mapUrl = "https://www.google.ca/maps/place/" + encodeURI(store.address);
  	return <div className={"col-sm-6 store"  + (this.props.noFade ? "" : " fade-in")}>
        <div className="for-border" ref="divForBoder">
            <img src={store.img_large} className="store-img hidden-xs"
                 onLoad={this.imageLoaded}></img>
            <a href={mapUrl} target="_blank"><img src={store.img_small} className="store-map"></img></a>
            <h2 className="store-name">{store.title}</h2>
            {ecco}
            <address className="store-address">{store.address}<br/>
            {store.phone}<br/><a href={"mailto:" + store.email}>{store.email}</a></address>
            <h5 className="store-hours">Store Hours</h5>
            <ul>
              <li>{store.hours1}</li>
              <li>{store.hours2}</li>
              <li>{store.hours3}</li>
              {hour4}
            </ul>
            <p onClick={this.requestFitting} className="request-link">Book Fitting Appointment</p>
            { "true" == store.showJob ? <Link to={"/career"}>View Job Openings</Link> : null }
        </div>
  	  </div>
  }
});

var Row = React.createClass({

  stores: [],
  hei1: 0,

  createStores: function() {
  	var index = 0;

    return this.props.stores.map(function(store){
      store.index = index;
      index++;
      return <Store store={store} showFittingReqForm={this.props.showFittingReqForm}
                    imageLoaded={this.storeImageLoaded} noFade={this.props.noFade}
                    ref={function(s){ this.stores.push(s); }.bind(this)}
                    key={index}></Store>
    }.bind(this));
  },

  storeImageLoaded: function(hei) {
    if (this.hei1) {
      var maxHei = Math.max(this.hei1, hei);

      this.stores[0].setBorderDivHei(maxHei);
      this.stores[1].setBorderDivHei(maxHei);
    } else {
      this.hei1 = hei;
    }
  },

  render: function() {
    return <div className="row">
        {this.createStores()}
      </div>
  }
});

var Rows = React.createClass({

  render: function() {
    var rows = [];
    var stores = _.clone(CMS.stores.stores);
    
    while (stores.length) {
      var row = [];

      row.push(stores.shift());
      if (stores.length) row.push(stores.shift());

      rows.push(row);
    }
    var i = 0;
    var row_divs = rows.map(function(row){
      i++;
      return <Row stores={row} key={i} noFade={ 1 == i ? true : false }
                  showFittingReqForm={this.props.showFittingReqForm} />
    }.bind(this));
    return <section id="stores">
               {row_divs}
           </section>
  }
});

module.exports = React.createClass({

  mixins: [ ScrollToTop ],

  componentDidMount: function() {
    this.scrollToTop('stores-page');

    jQuery.get("https://cdn.contentful.com/spaces/rlfcmtla1qka/entries?access_token=b662bd9ebf9e31fef829fd18269143bf03bf8f52a6cb489cc210770d861ec183",
      function(result) {
        console.log(result);
        jQuery(jQuery('.store-name')[0]).html(result.items[0].fields['name']);
      })
  },

  render: function() {

    var desc = jQuery('<div/>').html(CMS.stores.desc).text();
    desc = jQuery('<p>').html(desc)[0];

  	return <div>
        <HeaderPage image={CMS.stores.header_img} imageM={CMS.stores.header_imgM}
                    prefix={CMS.stores.prefix} title={CMS.stores.title}
                    mainDescDiv={desc}/>
        <main id="content" className="container" role="main">
            <Rows ref="rows" showFittingReqForm={this.props.showFittingReqForm} />
            <section id="main-office">
                <p className="lead">{CMS.stores.hqPrefix}</p>
                <h1>{CMS.stores.hqTitle}</h1>
                <address>{CMS.stores.hqAddress}<br/>
                {CMS.stores.hqPhone} | <a href={"mailto:" + CMS.stores.hqEmail}>{CMS.stores.hqEmail}</a></address>
            </section>
        </main>
      </div>
  }
});